// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","239":"2f822dd7","455":"a08a12fe","749":"d2d98f97","903":"6315f363","904":"cda562b1"}[chunkId] + ".chunk.js";
};